import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TeamSettingsLayout } from '../../components/TeamSettingsLayout';
import { useGetTeamByTeamId } from '../../hooks/queries/useGetTeamByTeamId';
import { TeamCardEdit } from '../../components/TeamCardEdit/TeamCardEdit';
import { Alert } from '../../components/Alert/Alert';
import { Paragraph } from '../../components/Paragraph';
import { GhostLoader } from '../../components/GhostLoader';

export const Team = () => {
  const { t } = useTranslation();
  const { teamId } = useParams();
  const { data: teamData, isLoading, error } = useGetTeamByTeamId(Number(teamId));

  const content = () => {
    if (teamId === undefined) {
      return <Paragraph size="md">{t('teamSettings.errors.teamNotFound')}</Paragraph>;
    }
    if (isLoading) {
      return <GhostLoader style={{ height: 345, width: '100%' }} />;
    }
    if (error) {
      return (
        <Alert title={error.name} variant="danger" size="lg">
          <Paragraph size="md">{error.message}</Paragraph>
        </Alert>
      );
    }
    if (!teamData) {
      return <Paragraph size="md">{t('teamSettings.errors.teamNotFound')}</Paragraph>;
    }
    return (
      <TeamCardEdit
        teamName={teamData.name}
        numberOfTeamMembers={teamData.numberOfTeamMembers}
        workLanguage={teamData.workLanguage}
        teamId={Number(teamId)}
      />
    );
  };

  return <TeamSettingsLayout>{content()}</TeamSettingsLayout>;
};
